/** @format */

import { createContext, useContext } from "react";

/**
 * Azioni e stato condivisi con i nodi del grafico.
 * Passarli via contesto (invece che dentro node.data) evita di ricalcolare
 * il layout quando cambiano solo i callback o lo stato di trascinamento.
 */
export interface TOrgChartContext {
  canUpdate: boolean;
  /** persona che si sta trascinando dal pannello (null se nessuna) */
  draggingUserId: number | null;
  /** id di chi non può ricevere la persona trascinata (sé stessa e i suoi collaboratori) */
  blockedDropIds: Set<number>;
  onOpenPerson: (personId: number) => void;
  onAddCollaborator: (managerId: number) => void;
  onToggleCollapse: (personId: number) => void;
  onRemovePerson: (personId: number) => void;
  onDropUser: (managerId: number | null, userId: number) => void;
}

const noop = (): void => undefined;

export const OrgChartContext = createContext<TOrgChartContext>({
  canUpdate: false,
  draggingUserId: null,
  blockedDropIds: new Set(),
  onOpenPerson: noop,
  onAddCollaborator: noop,
  onToggleCollapse: noop,
  onRemovePerson: noop,
  onDropUser: noop,
});

export const useOrgChart = (): TOrgChartContext => useContext(OrgChartContext);

/** Tipo MIME usato nel drag & drop dal pannello persone. */
export const DRAG_MIME = "application/x-org-user";
